import { render } from "./quotes.vue?vue&type=template&id=6d5c8f7a"
import script from "./quotes.vue?vue&type=script&lang=js"
export * from "./quotes.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\e2efreight\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__